export const VAT_RATES = [0, 9, 21];
export function assertCents(v, label = 'amount') {
    if (!Number.isSafeInteger(v))
        throw new Error(`${label} must be an integer number of cents, got ${v}`);
    return v;
}
/** Parse a user/bank formatted amount ("1.234,56", "1234.56", "-12,5", "€ 3,00") into cents. */
export function parseAmount(input) {
    let s = input.trim().replace(/[€\s]/g, '').replace(/^EUR/i, '');
    let negative = false;
    if (s.startsWith('(') && s.endsWith(')')) {
        negative = true;
        s = s.slice(1, -1);
    }
    if (s.startsWith('-')) {
        negative = true;
        s = s.slice(1);
    }
    else if (s.startsWith('+'))
        s = s.slice(1);
    if (s.endsWith('-')) {
        negative = true;
        s = s.slice(0, -1);
    }
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    let intPart;
    let fracPart = '';
    const decimalSep = lastComma > lastDot ? ',' : lastDot > lastComma ? '.' : null;
    if (decimalSep) {
        const idx = s.lastIndexOf(decimalSep);
        const tail = s.slice(idx + 1);
        // "1.234" with dot and exactly 3 digits and no other separator is ambiguous; treat 3-digit tail after a
        // thousands-looking separator as thousands only when the other separator is present before it.
        if (tail.length === 3 && ((decimalSep === '.' && lastComma === -1 && /^\d{1,3}(\.\d{3})+$/.test(s)) ||
            (decimalSep === ',' && lastDot === -1 && /^\d{1,3}(,\d{3})+$/.test(s)))) {
            intPart = s.replace(/[.,]/g, '');
        }
        else {
            intPart = s.slice(0, idx).replace(/[.,]/g, '');
            fracPart = tail;
        }
    }
    else {
        intPart = s;
    }
    if (!/^\d*$/.test(intPart) || !/^\d*$/.test(fracPart) || (intPart + fracPart) === '') {
        throw new Error(`Cannot parse amount: ${input}`);
    }
    const frac = (fracPart + '00').slice(0, 2);
    // round half up on a third decimal if present
    const third = fracPart.length > 2 ? Number(fracPart[2]) : 0;
    let cents = Number(intPart || '0') * 100 + Number(frac);
    if (third >= 5)
        cents += 1;
    return negative ? -cents : cents;
}
/** Floor to whole euros (towards -infinity). Used for VAT payable and turnover (in favour of the taxpayer). */
export function floorEuro(cents) {
    return Math.floor(cents / 100);
}
/** Ceil to whole euros. Used for deductible input VAT (voorbelasting). */
export function ceilEuro(cents) {
    return Math.ceil(cents / 100);
}
/** VAT for a net amount at a rate, rounded half away from zero to cents. */
export function vatOf(netCents, rate) {
    const raw = (netCents * rate) / 100;
    return raw >= 0 ? Math.round(raw) : -Math.round(-raw);
}
const LOCALE_TAG = { nl: 'nl-NL', en: 'en-GB', zh: 'zh-CN' };
/** Format cents as a currency string for the UI language. */
export function formatCents(cents, locale = 'nl', opts = {}) {
    const decimals = opts.decimals ?? true;
    const value = decimals ? cents / 100 : Math.trunc(cents / 100);
    return new Intl.NumberFormat(LOCALE_TAG[locale], {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: decimals ? 2 : 0,
        maximumFractionDigits: decimals ? 2 : 0,
    }).format(value);
}
/** Format whole euros (portal values) without currency symbol or separators: what the user types in the portal. */
export function portalValue(euros) {
    return String(euros);
}
export function sumCents(values) {
    return values.reduce((a, b) => a + b, 0);
}
//# sourceMappingURL=money.js.map